// extracted by mini-css-extract-plugin
module.exports = {"note":"PassModal_note__2jZHX"};